import _ from 'lodash';
import {
    GET_HERE_NOW,
    GET_PARTICIPANTS,
} from '../Actions/actionTypes';

export default (state=[],action) => {
    switch (action.type) {
        case GET_PARTICIPANTS:
            if(state.Participants && state.Participants.results.Participants) {
                if(state.Participants.results.Participants.length < state.Participants.results.TotalRecords) {
                    if(action.payload.Participants && action.payload.Participants.results.Participants) {
                        state.Participants.results.Participants = state.Participants.results.Participants.concat(action.payload.Participants.results.Participants);
                    }
                    else if(action.payload.results.ResponseCode) {
                        state.Participants.results.Participants = state.Participants.results.Participants.concat(action.payload.results.Participants);
                    }
                }
            }
            else {
                state.Participants = action.payload
            }
            return _.cloneDeep({...state});
        case GET_HERE_NOW:
            return {...state,HereNow:action.payload};
        default:
            return state;
    }
};